import Grid from '@material-ui/core/Grid';
import LayoutBox from "./LayoutBox";
import ToggleHeader from "../ToggleHeader";
import Layers from "./Layers";
import MapConfig from "./MapConfig";
import PlanEditor from "./PlanEditor";
import { headerVisibleState } from "../../store/HeaderVisibleState";
import { useRecoilValue } from "recoil";
import ExitToApp from "./ExitToApp";
import wniLogoImg from "../../images/wni_logo.png";

function Header() {
  const headerVisible = useRecoilValue(headerVisibleState);

  return (
    <>
      <header id="header" className="header" style={{ display: headerVisible ? '' : 'none' }}>
        <div id="site-logo">
          <img src={wniLogoImg} height={26} alt={"site-logo"}/>
        </div>
        <Grid container justifyContent="center" className={"header-menu-box"} style={{justifyContent: "flex-end"}}>
          <Grid item>
            <PlanEditor/>
          </Grid>
          <Grid item>
            <Layers/>
          </Grid>
          <Grid item>
            <MapConfig/>
          </Grid>
          <Grid item>
            <LayoutBox/>
          </Grid>
          <Grid item>
            <ExitToApp/>
          </Grid>
        </Grid>
      </header>
      <ToggleHeader/>
    </>
  );
}

export default Header;